import React from 'react';
import './pages/custom.css';

const AppFooter = (props) => {
    return (
        <div className="layout-footer">
            <span className="footer-text-left">
            {/*    <img alt="Logo" src={'assets/layout/images/logo' + (props.layoutScheme === 'light' ? '-dark.png' : '.png')} /> */}
            Copyright@2025 Gravitysoft. All rights reserved.
            </span>
            <span className="footer-text-right">
             {/*    <button className="p-link">
                    <i className="pi pi-facebook"></i>
                </button>
                <button className="p-link">
                    <i className="pi pi-twitter"></i>
                </button>
                <button className="p-link">
                    <i className="pi pi-github"></i>
                </button> */}
                Developed: Gravitysoft
            </span>
        </div>
    );
};

export default AppFooter;
